import React, { Component, Fragment } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import Button from "../../../shared/button/Button";
import Sending from "../../../shared/loaders/Sending";
import ModalThankYou from "../../../shared/loaders/ModalThankYou";
import {
  Wrapper,
  Form,
  Label,
  Field,
  TextInput,
  ButtonsWrapper,
  FileInputLabel,
  FileInput,
  Filename,
  RemoveAttachment,
  Error,
} from "./styles/first-interview-styles";

class FirstInterview extends Component {
  constructor(props) {
    super(props);
    this.attachmentRef = React.createRef();

    this.state = {
      formLoading: false,
      successMessageActive: false,
      message: "",
      attachment: "",
      fileAttached: false,
      error: null,
    };
  }

  showSuccessMessage = () => {
    this.setState({ successMessageActive: true });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });
    const { message, attachment } = this.state;
    const { cardData, closeActionModalAfterSubmit, fetchKanbanData } =
      this.props;
    const { updateStatusLink } = cardData;
    const url = updateStatusLink;

    const formData = new FormData();

    formData.append("application_action[action]", "first_interview_requested");
    formData.append("application_action[message]", message);
    formData.append("application_action[attachment]", attachment);
    formData.append("application_action[action_at]", Date.now());

    const payload = {
      url,
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    };

    axios(payload)
      .then(() => {
        this.setState({ formLoading: false, error: null });
        this.showSuccessMessage();
        setTimeout(() => {
          closeActionModalAfterSubmit();
          fetchKanbanData({ loading: false, updating: true });
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          error: error.response.data.errors,
          formLoading: false,
        });
      });
  };

  handleMessage = (e) => {
    this.setState({ message: e.target.value });
  };

  handleAttachment = (e) => {
    this.setState({ attachment: e.target.files[0], fileAttached: true });
  };

  removeAttachment = () => {
    const node = this.attachmentRef.current;

    this.setState({ attachment: "", fileAttached: false });
    node.value = null;
  };

  handleCancel = (e) => {
    e.preventDefault();
    const { closeActionModalAfterReset } = this.props;
    this.setState({ message: "", error: null });
    closeActionModalAfterReset();
  };

  render() {
    const { formLoading, successMessageActive, message, error, fileAttached } =
      this.state;
    const { cardData } = this.props;
    const { candidate } = cardData;

    return (
      <Wrapper>
        {formLoading && <Sending white />}
        {successMessageActive && <ModalThankYou text="Interview requested" />}
        <Form onSubmit={this.handleSubmit}>
          <Label>
            You&apos;re about to request {""}
            <strong>first face to face interview</strong> with{" "}
            <strong>{candidate}</strong>.
          </Label>
          <Field>
            <TextInput
              error={error}
              value={message}
              placeholder="Please add your message..."
              onChange={this.handleMessage}
            />
            {error && error.message && (
              <Error className="animated bounceIn">
                Message {error.message}.
              </Error>
            )}
          </Field>
          <Field>
            <FileInputLabel htmlFor="file" fileAttached={fileAttached}>
              <FontAwesomeIcon icon={faPaperclip} />
            </FileInputLabel>
            <FileInput
              type="file"
              name="file"
              id="file"
              ref={this.attachmentRef}
              onChange={this.handleAttachment}
            />
            <Filename>
              {fileAttached
                ? `${this.attachmentRef.current.files[0].name.replace(
                    "C:\\fakepath\\",
                    ""
                  )}`
                : "Attach a file"}
            </Filename>
            {fileAttached && (
              <Fragment>
                <ReactTooltip
                  html
                  place="left"
                  type="dark"
                  effect="solid"
                  aria-haspopup="true"
                  id="remove-attachment-tooltip"
                />
                <RemoveAttachment
                  onClick={this.removeAttachment}
                  data-tip="Remove this attachment"
                  data-for="remove-attachment-tooltip"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </RemoveAttachment>
              </Fragment>
            )}
          </Field>
          <ButtonsWrapper>
            <Button
              secondary
              buttonName="Cancel"
              onClickAction={this.handleCancel}
            />
            <Button primary buttonName="Request Interview" type="submit" />
          </ButtonsWrapper>
        </Form>
      </Wrapper>
    );
  }
}

FirstInterview.propTypes = {
  closeActionModalAfterReset: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    updateStatusLink: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
};

export default FirstInterview;
